const UNDEFINED = 'undefined';

const getPartnerBroadcasterConfig = ({
    epglist,
    epgContentList,
    useContentEpg,
    epgConfig
}) => {
    let temp;

    if (typeof epgConfig === UNDEFINED) {
        return temp;
    }

    const epgDecision = useContentEpg === true && epgContentList ? epgContentList : epglist;

    for (let i = 0, len = epgDecision?.length ?? 0; i < len; i++) {
        const item = epgDecision[i];
        const { id } = item;
        const config = epgConfig[id];

        if (config) {
            const gamedata = item;
            const configdata = config;
            const useFgow = configdata?.useFgow;

            if (useFgow || (!useFgow && typeof gamedata !== UNDEFINED)) {
                temp = configdata;
                break;
            }
        }
    };

    return temp;
};

export default getPartnerBroadcasterConfig;
